export default {
  navbar: {
    home: 'ホーム',
    jobs: '求人',
    companies: '企業',
    about: '会社概要',
    customerService: 'カスタマーサービス',
    signIn: 'ログイン',
    register: '新規登録'
  },
  customerService: {
    title: 'カスタマーサービス',
    subtitle: '専門サポートチームが24時間いつでもあなたの質問に答えます。',
    onlineService: 'オンラインサービス',
    serviceDescription: '専門サポートチームが24時間いつでもサポートします。',
    startChat: 'オンラインチャットを開始',
    responseTime: '平均応答時間：30秒',
    instantResponse: '即時応答',
    instantResponseDesc: 'カスタマーサービスチームが24時間オンラインで待機し、平均応答時間は2分未満です',
    professionalTeam: 'プロフェッショナルチーム',
    professionalTeamDesc: '厳しい研修を受けたカスタマーサービススタッフで、すべての業務プロセスに精通しています',
    securityPrivacy: 'セキュリティとプライバシー',
    securityPrivacyDesc: 'すべての情報は暗号化され、絶対的な安全性を保証します',
    serviceOnline: 'サービスオンライン',
    seniorConsultant: 'シニアカスタマーコンサルタント'
  },
  home: {
    heroTitle: '映画業界であなたの夢の仕事を見つけよう',
    heroSubtitle: 'トップシネマとエンターテイメント企業と繋がりましょう。今日から刺激的な映画の世界で旅を始めましょう。',
    popularCategories: '人気求人カテゴリ',
    categoriesDescription: '様々な映画とエンターテイメント分野のチャンスを探検',
    featuredJobOpportunities: '特集求人',
    discoverLatestOpenings: 'トップシネマの最新求人情報をチェック',
    openPositions: '件募集中',
    quickApply: 'クイック応募',
    whyChooseUs: 'なぜ私たちを選ぶのか',
    joinLargestNetwork: '最大の映画専門家ネットワークに参加',
    categories: {
      theaterOperations: {
        title: 'シネマ運営',
        description: '日常的なシネマ運営を管理し、スムーズな上映を確保します'
      },
      boxOfficeManagement: {
        title: 'ボックスオフィス管理',
        description: 'ボックスオフィスでのチケット販売とカスタマーサービスを処理'
      },
      cinemaTechnology: {
        title: 'シネマテクノロジー',
        description: '最新のシネマ機器とシステムを維持・運用'
      },
      customerService: {
        title: 'カスタマーサービス',
        description: 'シネマの観客に優れたサービスを提供'
      },
      foodBeverage: {
        title: 'フード＆ドリンク',
        description: 'スナックコーナーとフードサービス運営を管理'
      },
      marketingPromotions: {
        title: 'マーケティング・プロモーション',
        description: 'シネマのマーケティング戦略を作成・実行'
      }
    },
    featuredJobs: {
      theaterManager: {
        title: 'シネママネージャー',
        company: 'AMCシネマ',
        location: 'ニューヨーク、NY',
        type: '正社員',
        salary: '$65K - $85K',
        benefit: '福利厚生'
      },
      digitalProjectionist: {
        title: 'デジタル上映技師',
        company: 'Regalシネマ',
        location: 'ロサンゼルス、CA',
        type: '正社員',
        salary: '$45K - $60K',
        benefit: '研修'
      },
      marketingCoordinator: {
        title: 'マーケティングコーディネーター',
        company: 'Cinemark',
        location: 'シカゴ、IL',
        type: '正社員',
        salary: '$50K - $65K',
        benefit: 'リモート'
      }
    },
    features: {
      largeIndustryNetwork: {
        title: '大規模産業ネットワーク',
        description: '世界中の2,500以上のシネマとエンターテイメント企業と繋がり',
        stat: '15,000人以上のアクティブユーザー'
      },
      verifiedEmployers: {
        title: '認証済み雇用主',
        description: 'すべての雇用主は厳格に審査され、実在する機会を保証',
        stat: '100%認証企業'
      },
      careerGrowth: {
        title: 'キャリア成長',
        description: '研修資源と昇進機会にアクセス',
        stat: '89%成功率'
      }
    }
  },
  jobs: {
    heroTitle: '私たちの映画ファミリーに参加しよう',
    heroSubtitle: '物語を生き生きとさせる魔法の一部になりましょう。成長中のチームに加わる情熱的な人材を募集しています。',
    viewPositions: '募集中のポジションを見る',
    currentOpenings: '現在募集中',
    department: '部署',
    location: '勤務地',
    applyNow: '今すぐ応募',
    whyJoinUs: 'なぜ一緒に働くのか',
    ourCulture: '私たちの文化',
    applicationProcess: '応募プロセス',
    startYourJourney: 'あなたの旅を始めよう',
    benefits: {
      freeMovieAccess: {
        title: '無料映画',
        description: 'あなたと家族のために無制限の無料映画を楽しめます。'
      },
      careerGrowth: {
        title: 'キャリア開発',
        description: '総合的な研修と明確な昇進経路。'
      },
      flexibleSchedule: {
        title: '柔軟なスケジュール',
        description: 'ワークライフバランスのための柔軟なスケジュールオプション。'
      }
    },
    jobList: [
      {
        title: 'シネマ運営マネージャー',
        location: 'ニューヨーク、NY',
        type: '正社員',
        description: '旗艦店舗で日常的なシネマ運営を主導し、優れたカスタマーサービスを確保します。'
      },
      {
        title: 'シニア上映技師',
        location: 'ロサンゼルス、CA',
        type: '正社員',
        description: '最適な鑑賞体験のためにデジタル上映システムを運用・維持管理します。'
      },
      {
        title: 'スナックチームリーダー',
        location: 'シカゴ、IL',
        type: '正社員',
        description: 'スナックコーナーの運営を管理し、プロのフードサービスチームを率います。'
      },
      {
        title: 'ゲストエクスペリエンススペシャリスト',
        location: 'マイアミ、FL',
        type: 'パートタイム',
        description: '優れたサービスを提供し、ゲストに忘れられない体験を作り上げます。'
      },
      {
        title: 'テクニカルサポートスペシャリスト',
        location: 'シアトル、WA',
        type: '正社員',
        description: 'シネマ機器とシステムを維持し、問題を解決します。'
      },
      {
        title: 'イベントコーディネーター',
        location: 'ボストン、MA',
        type: '正社員',
        description: '特別上映とプライベートシネマイベントを計画・実行します。'
      }
    ],
    testimonials: [
      {
        name: 'エミリー・リチャードソン',
        position: 'シネママネージャー',
        quote: 'ここで働くことは信じられない旅でした。成長の機会とサポート環境が、ここをただの仕事以上のものにしてくれます。'
      },
      {
        name: 'マイケル・アンダーソン',
        position: 'シニア上映技師',
        quote: '私たちが一緒に働くテクノロジーと機器は一流です。どんな映画愛好家にとっても、これは夢が叶ったようなものです。'
      },
      {
        name: 'サラ・マルティネス',
        position: 'イベントコーディネーター',
        quote: 'ここのチームワークは素晴らしいです。私たちは一緒にゲストに忘れられない体験を作ります。'
      }
    ],
    applicationSteps: [
      {
        title: 'オンライン応募',
        description: '私たちのキャリアポータルを通じて申請書を提出してください。'
      },
      {
        title: '初回審査',
        description: '48時間以内に私たちのチームが申請書を審査します。'
      },
      {
        title: '面接',
        description: '機会について話し合うために私たちのチームと会いましょう。'
      },
      {
        title: 'ようこそ',
        description: '私たちの映画ファミリーで旅を始めましょう。'
      }
    ]
  },
  companies: {
    searchPlaceholder: '企業を検索...',
    location: '勤務地',
    companySize: '企業規模',
    industry: '業界',
    openPositions: '件募集中',
    viewJobs: '求人を見る',
    loadMore: 'さらに企業を読み込む',
    companyList: [
      {
        name: 'ユニバーサル・エンターテイメント・グループ',
        location: 'ロサンゼルス、CA',
        size: '5,000人以上の従業員',
        description: '世界中で映画とテレビコンテンツを制作・配給する先駆的なグローバルエンターテイメント企業。'
      },
      {
        name: 'シネマーク・プロダクション',
        location: 'ニューヨーク、NY',
        size: '2,000-5,000人の従業員',
        description: '大規模映画と革新的なデジタルコンテンツを専門とする受賞歴のある制作スタジオ。'
      },
      {
        name: 'デジタル・シネマ・ソリューションズ',
        location: 'サンフランシスコ、CA',
        size: '1,000-2,000人の従業員',
        description: '革新的なソリューションを通じてデジタル映画体験を革新するテクノロジー駆動の企業。'
      },
      {
        name: 'パラマウント・デジタル・スタジオ',
        location: 'シカゴ、IL',
        size: '500-1,000人の従業員',
        description: '最新技術を通じて次世代のデジタルエンターテイメント体験を創造します。'
      },
      {
        name: 'グローバル・シアター・ネットワーク',
        location: 'マイアミ、FL',
        size: '1,000-2,000人の従業員',
        description: '主要都市に最新の施設を持つプレミアムシネマチェーンを運営します。'
      },
      {
        name: 'シルバースクリーン・テクノロジーズ',
        location: 'シアトル、WA',
        size: '500-1,000人の従業員',
        description: '現代映画産業のための最先端ソフトウェアソリューションを開発します。'
      }
    ]
  },
  about: {
    heroTitle: '会社概要',
    heroSubtitle: '創造性とテクノロジーが出会う場所で、革新的なレンズを通じて物語が生き生きとなります。',
    ourStory: '私たちのストーリー',
    storyParagraph1: 'シネマスタースタジオは2010年に設立され、過去10年以上映画イノベーションの最前線に立ってきました。私たちの旅はシンプルでありながら力強いビジョンで始まりました：世界中の観客と共鳴する魅力的なビジュアルストーリーを創造すること。',
    storyParagraph2: '今日、私たちはグローバルブランドと業界の才能あるアーティストと協力する先駆的な制作スタジオの1つとして誇りに思っています。卓越性への私たちのコミットメントと物語を伝える情熱は、私たちを前進させ続けます。',
    ourCoreValues: '私たちのコアバリュー',
    creativeExcellence: '創造的な卓越性',
    creativeExcellenceDesc: '限界を押し広げ、ビジュアルナラティブで新しい標準を設定します。',
    collaborativeSpirit: 'コラボレーティブ精神',
    collaborativeSpiritDesc: '一緒に努力してユニークなビジョンを現実にします。',
    qualityFirst: '品質優先',
    qualityFirstDesc: '私たちが創造するすべてのフレームで卓越性を追求します。',
    meetOurTeam: 'チーム紹介',
    creativeDirector: 'クリエイティブディレクター',
    leadCinematographer: '主任カメラマン',
    technicalDirector: 'テクニカルディレクター',
    productionManager: 'プロダクションマネージャー',
    yearsExperience: '年の経験',
    projectsCompleted: '完了したプロジェクト',
    industryAwards: '業界賞',
    happyClients: '幸せなクライアント'
  },
  footer: {
    copyright: '© 2025 TJH - Ticket Job Hub. All rights reserved.',
    description: '映画業界で才能と機会を繋げます。シネマ運営、管理、または技術職であなたの次の役割を見つけてください。',
    quickLinks: 'クイックリンク',
    jobSeeker: '求職者',
    newsletter: 'ニュースレター',
    newsletterText: '最新の求人更新とキャリアアドバイスを受け取るには、サブスクライブしてください。',
    emailPlaceholder: 'メールアドレス',
    subscribe: 'サブスクライブ',
    quickLinksList: ['会社概要', 'お問い合わせ', 'プライバシーポリシー', 'サービス利用規約'],
    jobSeekerLinksList: ['求人を探す', 'キャリアリソース', '履歴書のヒント', '求人アラート']
  }
}